module.exports = {
      id: "twitter-plain-color-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-b35941cc40d7fc0f39708cadaf87d26a.svg#twitter-plain-color",
      toString: function () {
        return this.url;
      }
    }